import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { DesktopResourceBrowser } from './Desktop/DesktopResourceBrowser';
import { MobileResourceBrowser } from './Mobile/MobileResourceBrowser';
import { useIsNarrowScreen } from '../common/useIsNarrowScreen';

function Dashboard() {
  const isNarrow = useIsNarrowScreen();
  const isImpersonating = useSelector((state) => state.impersonation.isImpersonating);
  const courseId = useSelector((state) => state.course.courseId);
  const showBanner = isImpersonating || !!courseId;

  if (isNarrow) {
    return (
      <Box className={`mss__dashboard narrow${showBanner ? ' impersonating' : ''}`} id="dashboard">
        <Box className="mss__box dashboardContent">
          <MobileResourceBrowser id="dashboard" />
        </Box>
      </Box>
    );
  }

  return (
    <Box className="mss__dashboard" id="dashboard">
      <Box className="mss__box dashboardContent">
        <DesktopResourceBrowser id="dashboard" />
      </Box>
    </Box>
  );
}

export default Dashboard;
